// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"aafd5e1b","498":"c4e2107a","703":"74531b97","787":"3e58d960"}[chunkId] + ".chunk.js";
};